import getKeys from './getKeys';

const formatKey = {
  year: 'YYYY',
  month: 'MM',
  day: 'DD',
  hour: 'hh',
  minute: 'mm'
} as const;

type FormatKey = typeof formatKey;
type FormatKeys = FormatKey[keyof FormatKey];

type YearKey = FormatKey['year'];
type MonthKey = FormatKey['month'];
type DayKey = FormatKey['day'];
type HourKey = FormatKey['hour'];
type MinuteKey = FormatKey['minute'];

type Format =
  | `${YearKey}${string}${MonthKey}${'月' | ''}`
  | `${YearKey}${string}${MonthKey}${string}${DayKey}${'日' | ''}`
  | `${YearKey}${string}${MonthKey}${string}${DayKey}${string}${HourKey}${string}${MinuteKey}${
      | '分'
      | ''}`
  | `${MonthKey}${string}${DayKey}${string}${HourKey}${string}${MinuteKey}`
  | `${MonthKey}${string}${DayKey}`;

/**
 * @param format YYYY-MM-DD hh:mm, YYYY年MM月DD日, YYYY/MM, etc.
 */
export const formatDate = (date: Date, format: Format) => {
  if (isNaN(date.getTime())) return '';

  const datePerFormatKey = {
    [formatKey.year]: date.getFullYear().toString(),
    [formatKey.month]: (date.getMonth() + 1).toString().padStart(2, '0'),
    [formatKey.day]: date.getDate().toString().padStart(2, '0'),
    [formatKey.hour]: date.getHours().toString().padStart(2, '0'),
    [formatKey.minute]: date.getMinutes().toString().padStart(2, '0')
  } as const;

  const regex = new RegExp(getKeys(datePerFormatKey).join('|'), 'g');

  return format.replace(
    regex,
    matchedFormatKey => datePerFormatKey[matchedFormatKey as FormatKeys] // NOTE: 推論されないのでasで固定
  );
};

/**
 * 現在から[引数の日時]までの日数を返す関数
 */
export const calculateNumberOfDifferenceDays = (date: string) => {
  const [currentDate, expirationDate] = [new Date(), new Date(date)];
  if (isNaN(expirationDate.getTime())) return null;

  const millisecondsPerDay = 1000 * 60 * 60 * 24;
  const differenceMilliseconds =
    expirationDate.getTime() - currentDate.getTime();
  return Math.ceil(differenceMilliseconds / millisecondsPerDay);
};

/**
 * [引数の日時]が現在から[引数の日数]以内かどうかを返す関数
 */
export const isWithinParamDays = (date: Date, days: number) => {
  if (isNaN(date.getTime())) return false;

  const paramDaysAgo = new Date();
  paramDaysAgo.setDate(paramDaysAgo.getDate() - days);
  return date >= paramDaysAgo;
};
